/* eslint-disable no-nested-ternary */
import { QuestionOption } from '@app/utils/hooks';
import {
  AnswerType,
  CriteriaType,
  QuestionCriterionView,
  TrialCriteriaView,
} from '@data/sdk/match';
import { AntdForm } from '@ui/components';

export type EditCriteriaFormValues = {
  answerType: AnswerType;
  maxThreshold?: number | null;
  minThreshold?: number | null;
  originalCriteriaText: string;
  otherValues?: string[] | null;
  question: Partial<QuestionOption>;
  type: CriteriaType;
  unit?: string | null;
  value?: boolean | null;
};

export const useFormData = (
  criteria:
    | TrialCriteriaView
    | (QuestionCriterionView & {
        answerType: AnswerType;
        questionId: string;
        questionText: string;
      }),
) => {
  const [form] = AntdForm.useForm<EditCriteriaFormValues>();

  const question = AntdForm.useWatch('question', form);
  const answerType = AntdForm.useWatch('answerType', form);

  const initialValues: EditCriteriaFormValues = {
    type: criteria.type,
    originalCriteriaText:
      (criteria as TrialCriteriaView)?.originalCriteriaText ||
      (criteria as QuestionCriterionView)?.criterionText,
    question: { value: criteria.questionId, label: criteria.questionText },
    answerType:
      criteria.answerType === AnswerType.Boolean || criteria.answerType === AnswerType.Number
        ? criteria.answerType
        : AnswerType.Boolean,
    value: criteria.answerType === AnswerType.Boolean ? criteria.value : null,
    minThreshold: criteria.minThreshold !== null ? criteria.minThreshold : null,
    maxThreshold: criteria.maxThreshold !== null ? criteria.maxThreshold : null,
    unit: criteria.unit ?? undefined,
    otherValues: criteria.otherValues,
  };

  return { form, question, answerType, initialValues };
};
